import { render, staticRenderFns } from "./WebPartFormDesignerToolbar.vue?vue&type=template&id=5e6670eb&scoped=true&"
import script from "./WebPartFormDesignerToolbar.vue?vue&type=script&lang=js&"
export * from "./WebPartFormDesignerToolbar.vue?vue&type=script&lang=js&"
import style0 from "./WebPartFormDesignerToolbar.vue?vue&type=style&index=0&id=5e6670eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6670eb",
  null
  
)

export default component.exports